import background_1 from "../../assets/organization_ppt/background_1.png";
import cover_page_image from "../../assets/organization_ppt/cover_page_img.png";
import emission_breakdown from "../../assets/organization_ppt/emission_breakdown.png";
import { addImageNonStretch, blackListitem, blackParagraph, darkParagraph, darkSubtitle, getBase64, whiteSidePageNumber, whiteSideSubtitle } from "./ExportProductPPT";
import { scope1Categories, scope2Categories, scope3Categories } from "../../pages/Organization/ScopeCategory";
export const whiteParagraph = {
  fontSize: 10,
  fontFace: "Poppins",
  color: "ffffff",
  align: "left",
  valign: "top",
  lineSpacing: 15,
};
export const whiteBoldParagraph = {
  fontSize: 10,
  fontFace: "Poppins",
  color: "ffffff",
  align: "left",
  valign: "top",
  lineSpacing: 15,
  bold: true,
};
export const whiteTitle = {
  fontSize: 26,
  fontFace: "Poppins",
  bold: true,
  color: "ffffff",
  lineSpacing: 40,
  align: "left",
  valign: "top",
};
export const greenTitle = {
  fontSize: 20,
  fontFace: "Poppins",
  bold: true,
  color: "4C7F25",
  align: "left",
  valign: "top",
};
export const greenSubtitle = {
  fontSize: 14,
  fontFace: "Poppins",
  bold: true,
  color: "4C7F25",
  align: "left",
  valign: "top",
};
export const whiteSideSubtitleContent = "C O R P O R A T E  C A R B O N  F O O T P R I N T  R E P O R T  2 0 2 5";
export const addCoverPage = async (pptx, data) => {
  let slide = pptx.addSlide();
  slide.background = { path: background_1 };
  const base64Img = await getBase64(cover_page_image);
  await addImageNonStretch(slide, base64Img, 6.88, 3.89, 6.56, 2.925);

  slide.addShape(pptx.ShapeType.rect, {
    x: 0.393,
    y: 4.015,
    w: 2.32,
    h: 0.02,
    fill: "EAC222",
  });
  slide.addShape(pptx.ShapeType.rect, {
    x: 0,
    y: 1.89,
    w: 4.5275,
    h: 1.77,
    fill: { color: "4C7F25", alpha: 12 },
  });
  slide.addText("Corporate GHG", { x: 0.3, y: 1.97, w: 5, h: 0.79, ...whiteTitle });
  slide.addText("Emission Report", { x: 0.3, y: 2.71, w: 5, h: 0.79, ...whiteTitle });
  slide.addText("Generated using Arivu.2025", { x: 0.3, y: 3.63, w: 3.05, h: 0.425, ...blackParagraph });
  slide.addText(data?.company?.name || "Company Inc.", { x: 0.3, y: 4.055, w: 2.5, h: 0.52, ...darkSubtitle });
  slide.addText(`${data?.company?.address || "Address"} \n${data?.company?.phone || "Phone"} \n${data?.company?.website || "Website"}`, {
    x: 0.3,
    y: 4.37,
    w: 2.7,
    h: 0.71,
    ...darkParagraph,
  });
};
export const addExecutiveSummary = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  const base64Img = await getBase64(emission_breakdown);
  await addImageNonStretch(slide, base64Img, 3.77, 2.35, 7.6, 2.48);

  const titleH = 0.4;
  const paragraph3H = 0.937;
  const paragraph1H = 0.354;
  {
    const x = 0.75;
    const w = 4.37;
    slide.addText("Executive Summary", { x, y: 0.4, w, h: titleH, ...greenTitle });
    slide.addText("Objective", { x, y: 0.98, w, h: titleH, ...greenSubtitle });
    slide.addText(data.objective, { x, y: 1.23, w, h: paragraph3H, ...blackParagraph });
    slide.addText("Total GHG Emission", { x, y: 2.165, w, h: titleH, ...greenSubtitle });
    slide.addText(data.total_ghg_emission + " kgCO2e", { x, y: 2.4, w, h: paragraph1H, ...blackParagraph });
    slide.addText("Organizational Boundaries", { x, y: 2.756, w, h: titleH, ...greenSubtitle });
    slide.addText(data.organizational_boundaries, { x, y: 2.99, w, h: paragraph1H, ...blackParagraph });
    slide.addText("Base Year", { x, y: 3.386, w, h: titleH, ...greenSubtitle });
    slide.addText(data.base_year, { x, y: 3.622, w, h: paragraph1H, ...blackParagraph });
    slide.addText("Reporting Standard", { x, y: 4.13, w, h: titleH, ...greenSubtitle });
    slide.addText(data.reporting_standard, { x, y: 4.378, w, h: paragraph3H, ...blackParagraph });
  }
  slide.addShape(pptx.ShapeType.rect, {
    x: 5.2,
    y: 0.905,
    w: 0.02,
    h: 4.41,
    fill: "EAC222",
  });
  {
    const w = 0.83;
    const h = 0.7;
    const y = 3.54;
    const rectRadius = 0.1;
    slide.addShape(pptx.shapes.ROUNDED_RECTANGLE, { x: 5.88, y, w, h, rectRadius, fill: "608A37" });
    slide.addShape(pptx.shapes.ROUNDED_RECTANGLE, { x: 7.165, y, w, h, rectRadius, fill: "4AA2CE" });
    slide.addShape(pptx.shapes.ROUNDED_RECTANGLE, { x: 8.48, y, w, h, rectRadius, fill: "3CC583" });
  }
  {
    const w = 0.83;
    const y = 3.89;
    const align = "center";
    const text = "kgCO2e";
    slide.addText(text, { x: 5.88, y, w, h: paragraph1H, ...whiteParagraph, align });
    slide.addText(text, { x: 7.18, y, w, h: paragraph1H, ...whiteParagraph, align });
    slide.addText(text, { x: 8.48, y, w, h: paragraph1H, ...whiteParagraph, align });
  }
  {
    const w = 0.906;
    const y = 3.58;
    const h = paragraph1H;
    const align = "center";
    const scope1 = data.scope1GWP.toLocaleString("en-CA", { minimumSignificantDigits: 1, maximumSignificantDigits: 8 });
    const scope2 = data.scope2GWP.toLocaleString("en-CA", { minimumSignificantDigits: 1, maximumSignificantDigits: 8 });
    const scope3 = data.scope3GWP.toLocaleString("en-CA", { minimumSignificantDigits: 1, maximumSignificantDigits: 8 });
    slide.addText(scope1, { x: 5.827, y, w, h, ...whiteBoldParagraph, align });
    slide.addText(scope2, { x: 7.126, y, w, h, ...whiteBoldParagraph, align });
    slide.addText(scope3, { x: 8.425, y, w, h, ...whiteBoldParagraph, align });
  }
  num++;
  return num;
};
export const addScope = async (
  pptx,
  pageNum,
  scopeList,
  title,
  options = {
    headerColor: "FFFFFF",
    headerBackgroundColor: "5F7434",
    firstColumnColor: "4C7F25",
    firstColumnBackgroundColor: "FFFFFF",
    rowColor: "000000",
    rowBackgroundColor: "FFFFFF",
    borderColor: "4C7F25",
  }
) => {
  let num = pageNum;
  let tableBlocks = [];
  let maxLetters = 400;
  let currentBlock = [];
  let currentCount = 0;
  for (const item of scopeList) {
    const length = Math.max(item.category, item.description, item.gwp);
    if (currentCount + length > maxLetters && currentBlock.length > 0) {
      tableBlocks.push(currentBlock);
      currentBlock = [];
      currentCount = 0;
    }
    currentBlock.push(item);
    currentCount += length;
  }
  tableBlocks.push(currentBlock);
  for (const item of tableBlocks) {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText(title, { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenTitle });
    const tableData = [["Category", "Description", "GWP"], ...item.map((i) => [i.category, i.description, i.gwp.toLocaleString("en-US", { minimumIntegerDigits: 1 })])];
    const tableRows = tableData.map((row, rowIndex) =>
      row.map((cell, colIndex) => {
        if (rowIndex === 0) {
          return {
            text: cell,
            options: {
              fill: options.headerBackgroundColor,
              color: options.headerColor,
              bold: true,
              border: { pt: 1, color: options.borderColor },
              align: "center",
              valign: "middle",
            },
          };
        } else if (colIndex === 0) {
          return {
            text: cell,
            options: {
              fill: options.firstColumnBackgroundColor,
              color: options.firstColumnColor,
              border: { pt: 1, color: options.borderColor },
              align: "left",
              valign: "middle",
            },
          };
        } else {
          return {
            text: cell,
            options: {
              fill: options.rowBackgroundColor,
              color: options.rowColor,
              border: { pt: 1, color: options.borderColor },
              align: "left",
              valign: "middle",
            },
          };
        }
      })
    );
    slide.addTable(tableRows, { x: 0.8, y: 0.8, w: 8.7, colW: [3.8, 2.9, 2], fontSize: 12, fontFace: "Poppins" });
    num++;
  }
  return num;
};
export const addScope1 = async (pptx, data, pageNum) => {
  return addScope(pptx, pageNum, data.scope1, "Scope Emission Inventory (Scope 1)", {
    headerBackgroundColor: "E7E7E7",
    headerColor: "000000",
    firstColumnColor: "000000",
    borderColor: "ffffff",
    firstColumnBackgroundColor: "ebf1de",
    rowBackgroundColor: "ebf1de",
  });
};
export const addScope2 = async (pptx, data, pageNum) => {
  return addScope(pptx, pageNum, data.scope2, "Scope Emission Inventory (Scope 2)", {
    headerBackgroundColor: "E7E7E7",
    headerColor: "000000",
    firstColumnColor: "000000",
    borderColor: "ffffff",
    firstColumnBackgroundColor: "dbeef4",
    rowBackgroundColor: "dbeef4",
  });
};
export const addScope3 = async (pptx, data, pageNum) => {
  return addScope(pptx, pageNum, data.scope3, "Scope Emission Inventory (Scope 3)", {
    headerBackgroundColor: "E7E7E7",
    headerColor: "000000",
    firstColumnColor: "000000",
    borderColor: "ffffff",
    firstColumnBackgroundColor: "b8ead2",
    rowBackgroundColor: "b8ead2",
  });
};
export const addFootprint = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText("Environmental Footprint Chart", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenTitle });
  if (data.footprintEnvDoughnut) {
    await addImageNonStretch(slide, data.footprintEnvDoughnut, 3.44, 3.51, 2.417, 2.953);
  }
  if (data.footprintEnvBarchart) {
    await addImageNonStretch(slide, data.footprintEnvBarchart, 5.38, 3.51, 7.138, 2.874);
  }
  num++;
  return num;
};

export const addScopeSummaryTable = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText("Scope Summary", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenTitle });

  const getScopeBadgeColor = (scope) => {
    switch (scope) {
      case "Scope 1": return { bgColor: "fef2f2", color: "ef4444" };
      case "Scope 2": return { bgColor: "fffbeb", color: "f59e0b" };
      case "Scope 3": return { bgColor: "f0f9ff", color: "0ea5e9" };
      case "Avoided": return { bgColor: "f0fdf4", color: "22c55e" };
      case "Biogenic": return { bgColor: "f5f3ff", color: "8b5cf6" };
      default: return { bgColor: "f8fafc", color: "64748b" };
    }
  };

  const categoryToScope = (cat) => {
    if (scope1Categories.includes(cat)) return "Scope 1";
    if (scope2Categories.includes(cat)) return "Scope 2";
    if (scope3Categories.includes(cat)) return "Scope 3";
    return "Uncategorized";
  };

  const emissions = data.emissions || [];
  let categoryMap = {};
  
  emissions.forEach((item) => {
    const cat = item.category || "Unspecified";
    let scope = categoryToScope(cat);
    if (item.is_avoided) {
      scope = "Avoided";
    } else if (item.is_biogenic) {
      scope = "Biogenic";
    }

    const key = `${scope}-${cat}`;
    if (!categoryMap[key]) categoryMap[key] = { scope, category: cat, gwp: 0 };
    categoryMap[key].gwp += (Number(item.gwp) || 0);
  });

  const scopeOrder = { "Scope 1": 1, "Scope 2": 2, "Scope 3": 3, "Avoided": 4, "Biogenic": 5, "Uncategorized": 6 };
  const sorted = Object.values(categoryMap)
                  .filter(r => Math.abs(r.gwp) > 0)
                  .sort((a, b) => (scopeOrder[a.scope] ?? 9) - (scopeOrder[b.scope] ?? 9) || b.gwp - a.gwp);

  const grossTotal = sorted.reduce((sum, item) => sum + (["Scope 1", "Scope 2", "Scope 3"].includes(item.scope) ? Math.abs(item.gwp) : 0), 0);

  const tableHeaders = [
    { text: "Scope", options: { fill: "f8fafc", color: "0f172a", bold: true, fontSize: 12, border: { pt: 1, color: "e2e8f0" }, align: "center", valign: "middle" } },
    { text: "Category", options: { fill: "f8fafc", color: "0f172a", bold: true, fontSize: 12, border: { pt: 1, color: "e2e8f0" }, align: "left", valign: "middle" } },
    { text: "Emissions (kg CO₂e)", options: { fill: "f8fafc", color: "0f172a", bold: true, fontSize: 12, border: { pt: 1, color: "e2e8f0" }, align: "right", valign: "middle" } },
    { text: "% of Total", options: { fill: "f8fafc", color: "0f172a", bold: true, fontSize: 12, border: { pt: 1, color: "e2e8f0" }, align: "right", valign: "middle" } }
  ];

  const tableRows = [tableHeaders];

  sorted.forEach(row => {
    const badge = getScopeBadgeColor(row.scope);
    const pct = grossTotal > 0 ? ((Math.abs(row.gwp) / grossTotal) * 100).toFixed(2) + "%" : "0.00%";
    const formattedVal = Number(row.gwp).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
    tableRows.push([
      { text: ` ${row.scope} `, options: { fill: badge.bgColor, color: badge.color, bold: true, border: { pt: 1, color: "e2e8f0" }, align: "center", valign: "middle", fontFace: "Poppins" } },
      { text: row.category, options: { color: "334155", border: { pt: 1, color: "e2e8f0" }, align: "left", valign: "middle", fontFace: "Poppins" } },
      { text: formattedVal, options: { color: "334155", border: { pt: 1, color: "e2e8f0" }, align: "right", valign: "middle", fontFace: "Poppins" } },
      { text: pct, options: { color: "334155", border: { pt: 1, color: "e2e8f0" }, align: "right", valign: "middle", fontFace: "Poppins" } }
    ]);
  });

  slide.addTable(tableRows, {
    x: 0.5, y: 1.0, w: 9.0, rowH: 0.35,
    colW: [2.0, 4.0, 2.0, 1.0],
    fontSize: 10,
    fontFace: "Poppins"
  });

  num++;
  return num;
};

export const addReferences = (pptx, data, pageNum) => {
  const bullets = data.references.map((b) => b.trim().replace("•", "")).filter(Boolean);
  let bulletBlocks = [];
  let maxLetters = 1000;
  let currentBlock = [];
  let currentCount = 0;
  let num = pageNum;
  for (const item of bullets) {
    const length = item.length;
    if (currentCount + length > maxLetters && currentBlock.length > 0) {
      bulletBlocks.push(currentBlock);
      currentBlock = [];
      currentCount = 0;
    }
    currentBlock.push(item);
    currentCount += length;
  }
  bulletBlocks.push(currentBlock);
  for (const item of bulletBlocks) {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("References", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenTitle });
    slide.addText(
      item.map((i) => ({ text: i, options: { bullet: true, paraSpaceAfter: 10 } })),
      { x: 0.75, y: 0.85, w: 9, h: 4.4, ...blackListitem }
    );
    num++;
  }
  return num;
};
export const addInsights = (pptx, data, pageNum) => {
  let insightsBlocks = [];
  let maxLetters = 1000;
  let currentBlock = [];
  let currentCount = 0;
  let num = pageNum;
  if (!data.insights) {
    return num;
  }
  for (const item of data.insights) {
    const length = item.length;
    if (currentCount + length > maxLetters && currentBlock.length > 0) {
      insightsBlocks.push(currentBlock);
      currentBlock = [];
      currentCount = 0;
    }
    currentBlock.push(item);
    currentCount += length;
  }
  insightsBlocks.push(currentBlock);
  for (const item of insightsBlocks) {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("AI-generated insights", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenTitle });
    slide.addText(
      item.map((i) => ({ text: i, options: { bullet: true, paraSpaceAfter: 10 } })),
      { x: 0.75, y: 0.85, w: 9, h: 4.4, ...blackListitem }
    );
    num++;
  }
  return num;
};

// ========== BRSR SLIDES (Using existing template) ==========

// Helper to create table with Arivu green theme
const createBRSRTable = (slide, headers, data, x = 0.75, y = 2.0, w = 9.0) => {
  const colW = w / headers.length;
  slide.addShape("rect", { x, y, w, h: 0.4, fill: { color: "4C7F25" } });
  headers.forEach((header, index) => {
    slide.addText(header, { x: x + (index * colW), y: y, w: colW, h: 0.4, fontSize: 11, fontFace: "Poppins", bold: true, color: "FFFFFF", align: "center", valign: "middle" });
  });
  data.forEach((row, rowIndex) => {
    const rowY = y + 0.4 + (rowIndex * 0.35);
    const fillColor = rowIndex % 2 === 0 ? "f5f9f0" : "FFFFFF";
    slide.addShape("rect", { x, y: rowY, w, h: 0.35, fill: { color: fillColor }, line: { color: "4C7F25", pt: 0.5 } });
    row.forEach((cell, cellIndex) => {
      slide.addText(String(cell || 0), { x: x + (cellIndex * colW), y: rowY, w: colW, h: 0.35, fontSize: 10, fontFace: "Poppins", color: "000000", align: "center", valign: "middle" });
    });
  });
};

// BRSR Title Slide
export const addBRSRTitleSlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.background = { path: background_1 };
  const base64Img = await getBase64(cover_page_image);
  await addImageNonStretch(slide, base64Img, 6.88, 3.89, 6.56, 2.925);
  slide.addShape(pptx.ShapeType.rect, {
    x: 0.393, y: 4.015, w: 2.32, h: 0.02,
    fill: "EAC222",
  });
  slide.addShape(pptx.ShapeType.rect, {
    x: 0, y: 1.89, w: 4.5275, h: 1.77,
    fill: { color: "4C7F25", alpha: 12 },
  });
  slide.addText("Organization", { x: 0.3, y: 1.97, w: 5, h: 0.79, ...whiteTitle });
  slide.addText("Report", { x: 0.3, y: 2.71, w: 5, h: 0.79, ...whiteTitle });
  slide.addText("Generated using Arivu.2025", { x: 0.3, y: 3.63, w: 3.05, h: 0.425, ...blackParagraph });
  slide.addText(data.name || "Organization Name", { x: 0.3, y: 4.055, w: 2.5, h: 0.52, ...darkSubtitle });
  if (data.company) {
    const details = `${data.company.address || ""}\n${data.company.phone || ""}\n${data.company.website || ""}`;
    if (details.trim()) {
      slide.addText(details, { x: 0.3, y: 4.37, w: 2.7, h: 0.71, ...darkParagraph });
    }
  }
  return pageNum;
};

// BRSR Section Header Slide
export const addBRSRSectionHeader = async (pptx, title, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText(title, {
    x: 0.75,
    y: 3.0,
    w: 9.0,
    h: 1.0,
    fontSize: 28,
    fontFace: "Poppins",
    bold: true,
    color: "4C7F25",
    align: "center",
    valign: "middle",
  });

  return pageNum + 1;
};

// 1. Energy Slide
export const addBRSREnergySlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("1. Details of total energy consumption and energy intensity", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  slide.addText("Total electricity consumed (in GJ)", {
    x: 0.75, y: 1.0, w: 9.0, h: 0.3, ...blackParagraph
  });

  const headers = ["Parameter", "Current FY", "Previous FY"];
  const tableData = [
    ["Total Electricity Consumed", data.totalElectricity || 0, data.prevTotalElectricity || 0],
    ["Total Fuel Consumed", data.totalFuel || 0, data.prevTotalFuel || 0],
    ["Total Energy Consumed", data.totalEnergy || 0, data.prevTotalEnergy || 0],
    ["Energy Intensity", data.energyIntensity || 0, data.prevEnergyIntensity || 0],
  ];

  createBRSRTable(slide, headers, tableData, 0.75, 1.5, 9.0);
  return pageNum + 1;
};

// 2. PAT Scheme Slide
export const addBRSRPATSlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("2. PAT Scheme Designation", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  slide.addText(
    "Does the entity have any sites / facilities identified as designated consumers (DCs) under the Performance, Achieve and Trade (PAT) Scheme?",
    { x: 0.75, y: 1.2, w: 9.0, h: 0.8, ...blackParagraph }
  );

  slide.addText(data.patScheme || "Not applicable", {
    x: 0.75, y: 2.5, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
  });

  return pageNum + 1;
};

// 3. Water Slide
export const addBRSRWaterSlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("3. Water disclosures", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  const headers = ["Parameter", "Current FY", "Previous FY"];
  const tableData = [
    ["Surface Water (kl)", data.surfaceWater || 0, data.prevSurfaceWater || 0],
    ["Groundwater (kl)", data.groundwater || 0, data.prevGroundwater || 0],
    ["Third Party Water (kl)", data.thirdPartyWater || 0, data.prevThirdPartyWater || 0],
    ["Total Water Consumption", data.waterConsumption || 0, data.prevWaterConsumption || 0],
    ["Water Intensity", data.waterIntensity || 0, data.prevWaterIntensity || 0],
  ];

  createBRSRTable(slide, headers, tableData, 0.75, 1.2, 9.0);
  return pageNum + 1;
};

// 4. Zero Liquid Discharge Slide
export const addBRSRZLDSlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("4. Zero Liquid Discharge", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  slide.addText("Has the entity implemented a mechanism for Zero Liquid Discharge?", {
    x: 0.75, y: 1.2, w: 9.0, h: 0.6, ...blackParagraph
  });

  slide.addText(data.zeroLiquidDischarge || "Not applicable", {
    x: 0.75, y: 2.5, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
  });

  return pageNum + 1;
};

// 5. Air Emissions Slide
export const addBRSRAirEmissionsSlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("5. Air emissions (other than GHG)", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  const headers = ["Parameter", "Unit", "Current FY", "Previous FY"];
  const tableData = [
    ["NOx", "Kg", data.nox || 0, data.prevNox || 0],
    ["SOx", "Kg", data.sox || 0, data.prevSox || 0],
    ["Particulate Matter", "Kg", data.pm || 0, data.prevPm || 0],
    ["VOC", "Kg", data.voc || 0, data.prevVoc || 0],
  ];

  createBRSRTable(slide, headers, tableData, 0.75, 1.2, 9.0);
  return pageNum + 1;
};

// 6. GHG Emissions Slide
export const addBRSRGHGSlide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("6. Greenhouse gas emissions (Scope 1 and Scope 2)", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  const headers = ["Parameter", "Unit", "Current FY", "Previous FY"];
  const tableData = [
    ["Total Scope 1 Emissions", "Metric tonnes CO2e", data.scope1 || 0, data.prevScope1 || 0],
    ["Total Scope 2 Emissions", "Metric tonnes CO2e", data.scope2 || 0, data.prevScope2 || 0],
    ["Total Scope 1 + 2", "Metric tonnes CO2e",
      (data.scope1 || 0) + (data.scope2 || 0),
      (data.prevScope1 || 0) + (data.prevScope2 || 0)
    ],
    ["GHG Intensity", "Per Rupee", data.ghgIntensity || 0, data.prevGhgIntensity || 0],
  ];

  createBRSRTable(slide, headers, tableData, 0.75, 1.2, 9.0);
  return pageNum + 1;
};

// 7. Scope 3 Slide (Leadership Indicator)
export const addBRSRScope3Slide = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

  slide.addText("Total Scope 3 emissions", {
    x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
  });

  const headers = ["Parameter", "Unit", "Current FY", "Previous FY"];
  const tableData = [
    ["Total Scope 3 Emissions", "Metric tonnes CO2e", data.scope3 || 0, data.prevScope3 || 0],
    ["Scope 3 Intensity", "Per Rupee", data.scope3Intensity || 0, data.prevScope3Intensity || 0],
  ];

  createBRSRTable(slide, headers, tableData, 0.75, 1.5, 9.0);
  return pageNum + 1;
};






// 7. GHG Reduction Projects Slide
export const addBRSRGHGReductionSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("7. GHG reduction projects", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText("Does the entity have any project related to reducing Green House Gas emission?", {
        x: 0.75, y: 1.2, w: 9.0, h: 0.6, ...blackParagraph
    });

    slide.addText(data.ghgReductionProjects || "Under evaluation", {
        x: 0.75, y: 2.5, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
    });

    return pageNum + 1;
};

// 8. Waste Management Slide
export const addBRSRWasteSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("8. Waste management", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    const headers = ["Parameter", "Current FY (MT)", "Previous FY (MT)"];
    const tableData = [
        ["Plastic Waste", data.plasticWaste || 0, data.prevPlasticWaste || 0],
        ["E-waste", data.ewaste || 0, data.prevEwaste || 0],
        ["Bio-medical Waste", data.biomedicalWaste || 0, data.prevBiomedicalWaste || 0],
        ["Recycled", data.recycled || 0, data.prevRecycled || 0],
        ["Landfilling", data.landfilling || 0, data.prevLandfilling || 0],
    ];

    createBRSRTable(slide, headers, tableData, 0.75, 1.2, 9.0);
    return pageNum + 1;
};

// 9. Waste Management Practices Slide
export const addBRSRWastePracticesSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("9. Waste management practices", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText(data.wasteManagementPractices || "Standard waste management practices are followed as per regulatory requirements.", {
        x: 0.75, y: 1.5, w: 9.0, h: 3.0, ...blackParagraph
    });

    return pageNum + 1;
};

// 10. Ecological Areas Slide
export const addBRSREcologicalSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("10. Operations in ecologically sensitive areas", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText("No operations in ecologically sensitive areas", {
        x: 0.75, y: 2.0, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
    });

    return pageNum + 1;
};

// 11. EIA Projects Slide
export const addBRSREIASlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("11. Environmental impact assessments", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText("No EIA projects undertaken in the current year", {
        x: 0.75, y: 2.0, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
    });

    return pageNum + 1;
};

// 12. Environmental Compliance Slide
export const addBRSRComplianceSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("12. Environmental compliance", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText(data.environmentalCompliance || "The entity is compliant with all applicable environmental laws and regulations.", {
        x: 0.75, y: 1.5, w: 9.0, h: 3.0, ...blackParagraph
    });

    return pageNum + 1;
};

// LEADERSHIP INDICATORS

// L1. Renewable Energy Slide
export const addBRSRRenewableEnergySlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("1. Renewable vs Non-renewable energy", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    const headers = ["Parameter", "Current FY (GJ)", "Previous FY (GJ)"];
    const tableData = [
        ["Renewable Electricity", data.renewableElectricity || 0, data.prevRenewableElectricity || 0],
        ["Renewable Fuel", data.renewableFuel || 0, data.prevRenewableFuel || 0],
        ["Non-Renewable Electricity", data.nonRenewableElectricity || 0, data.prevNonRenewableElectricity || 0],
        ["Non-Renewable Fuel", data.nonRenewableFuel || 0, data.prevNonRenewableFuel || 0],
    ];

    createBRSRTable(slide, headers, tableData, 0.75, 1.2, 9.0);
    return pageNum + 1;
};

// L2. Water Discharge Slide
export const addBRSRWaterDischargeSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("2. Water discharge details", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    const headers = ["Destination", "With Treatment (kl)", "Without Treatment (kl)"];
    const tableData = [
        ["Surface Water", data.dischargeSurfaceWithTreatment || 0, data.dischargeSurfaceNoTreatment || 0],
        ["Groundwater", data.dischargeGroundWithTreatment || 0, data.dischargeGroundNoTreatment || 0],
        ["Seawater", data.dischargeSeaWithTreatment || 0, data.dischargeSeaNoTreatment || 0],
        ["Third Party", data.dischargeThirdPartyWithTreatment || 0, data.dischargeThirdPartyNoTreatment || 0],
    ];

    createBRSRTable(slide, headers, tableData, 0.75, 1.2, 9.0);
    return pageNum + 1;
};

// L3. Water Stress Slide
export const addBRSRWaterStressSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("3. Water withdrawal in water-stressed areas", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText(data.waterStressDetails || "Not applicable", {
        x: 0.75, y: 2.0, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
    });

    return pageNum + 1;
};

// L5. Biodiversity Impact Slide
export const addBRSRBiodiversitySlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("5. Biodiversity impact", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText(data.biodiversityImpact || "No significant impact identified", {
        x: 0.75, y: 2.0, w: 9.0, h: 2.0, ...blackParagraph, fontSize: 14, bold: true
    });

    return pageNum + 1;
};

// L6. Resource Efficiency Initiatives Slide
export const addBRSRResourceInitiativesSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("6. Resource efficiency initiatives", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText("• Energy efficiency improvements\n• LED lighting upgrades\n• Waste reduction programs", {
        x: 0.75, y: 1.5, w: 9.0, h: 3.0, ...blackParagraph
    });

    return pageNum + 1;
};

// L7. Disaster Management Slide
export const addBRSRDisasterManagementSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("7. Disaster management plan", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText(data.disasterManagementPlan || "A comprehensive business continuity and disaster management plan is in place.", {
        x: 0.75, y: 1.5, w: 9.0, h: 3.0, ...blackParagraph
    });

    return pageNum + 1;
};

// L8. Value Chain Impact Slide
export const addBRSRValueChainSlide = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(pageNum.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide.addText("8. Value chain environmental impact", {
        x: 0.75, y: 0.4, w: 9.0, h: 0.5, ...greenTitle, fontSize: 16
    });

    slide.addText(data.valueChainImpact || "No significant adverse impacts identified", {
        x: 0.75, y: 1.5, w: 9.0, h: 1.5, ...blackParagraph
    });

    slide.addText("Assessment Coverage: " + (data.valueChainAssessment || "Currently under assessment - estimated 30% coverage"), {
        x: 0.75, y: 3.2, w: 9.0, h: 1.5, ...blackParagraph
    });

    return pageNum + 1;
};

